/**
 * O que faz: Centraliza a animação de entrada e saída dos modais centrais.
 * Onde usa: DialogContent e AlertDialogContent.
 * Conexões: Tailwind CSS, tailwindcss-animate e preferência do sistema por reduzir movimento.
 * Tabelas: Nenhuma.
 * Data: 29/08/2026.
 */

// Usa somente opacidade e escala para a composição não provocar recálculo de layout.
// A curva de chegada desacelera perto do destino para o modal assentar sem o salto percebido no easing genérico.
export const centralModalMotionClasses = [
  'data-[state=open]:animate-in',
  'data-[state=open]:fade-in-0',
  'data-[state=open]:zoom-in-95',
  'data-[state=open]:[animation-duration:220ms]',
  'data-[state=open]:[animation-timing-function:cubic-bezier(0.16,1,0.3,1)]',
  'data-[state=closed]:animate-out',
  'data-[state=closed]:fade-out-0',
  'data-[state=closed]:zoom-out-98',
  'data-[state=closed]:[animation-duration:160ms]',
  'data-[state=closed]:[animation-timing-function:cubic-bezier(0.4,0,1,1)]',
  'motion-reduce:!animate-none',
].join(' ');
